import { isNonBlankString } from '../types.util';

/** Checks whether a string can be parsed as a date; does not require ISO format. */
export const isParseableDateString = (value: unknown): value is string =>
  isNonBlankString(value) && Number.isFinite(Date.parse(value));
